define(['underscore', 'text!./templates/basler-string-boolean-toggler.html'],
    (_, templateStr) => {

        return [() => {
                return {
                    restrict: 'E',
                    template: templateStr,
                    scope: {
                        /** Model (value) to select. */
                        model: '=',
                        /** Text on the component first choice */
                        firstChoiceLabel: '@',
                        /** Text on the component second choice */
                        secondChoiceLabel: '@',
                        /** Value of first choice, this will be set in the model */
                        firstChoiceValue: '=',
                        /** Value of second choice, this will be set in the model */
                        secondChoiceValue: '=',
                        /** Should the element be disabled */
                        disabled: '=',
                        /** Function to be called when the model changes */
                        onChange: '&',
                    },
                    link: function ($scope) {

                        $scope.show2ndChoice = ($scope.secondChoiceValue || $scope.secondChoiceLabel);

                        function callOnChangeCallback(newValue) {
                            if (_.isFunction($scope.onChange)) {
                                $scope.onChange({newValue: newValue});
                            }
                        }

                        $scope.firstClicked = function () {
                            if (!$scope.disabled) {
                                $scope.model = $scope.firstChoiceValue;
                                callOnChangeCallback($scope.firstChoiceValue);
                            }
                        };

                        $scope.secondClicked = function () {
                            if (!$scope.disabled) {
                                $scope.model = $scope.secondChoiceValue;
                                callOnChangeCallback($scope.secondChoiceValue);
                            }
                        };
                    },
                };
            }];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerToggler.js